/**
 * Schermteksten in het Portugees.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const pt: Teksten = {
  kamerOphalen: "A carregar sala…",
  kamerWerktNiet: "Esta sala não funciona",
  serverReageertNiet: "O servidor não responde",
  probeerOpnieuw: "Tenta novamente",
  vraagNieuweCode: "Pede um código novo a quem o partilhou. As salas expiram após algumas horas.",
  welkeTaalSprekJij: "Que língua falas?",
  jouwStem: "A tua voz na tradução",
  man: "Masculina",
  vrouw: "Feminina",
  pincode: "Código PIN",
  pincodeUitleg: "É-te fornecido por quem partilhou o código.",
  gaDeKamerIn: "Entrar na sala",
  kiesEerstJeTaal: "Escolhe primeiro a tua língua",
  microfoonAanvragen: "A solicitar microfone…",
  toestemmingUitleg: "O teu navegador vai pedir autorização para aceder ao microfone. Sem ela, apenas poderás digitar.",
  microfoonTestLink: "Testa primeiro o teu microfone",
  stemGaatMee: "Nesta sala, a outra pessoa também ouve a tua própria voz, além da tradução.",
  alleenChatMelding: "Esta conversa é só chat. Escreves as tuas mensagens e lês a tradução; nada é lido em voz alta.",
  verlooptOm: "Expira às",
  nooitVasteKamer: "Nunca, sala permanente",
  kamer: "Sala",
  tolkgesprek: "Conversa traduzida",
  juisteKamer: "Estás na sala certa. Em breve poderás falar aqui.",
  jij: "tu",
  deAnder: "o outro",
  verbinden: "A ligar…",
  verbonden: "Ligado",
  verbindingKwijt: "Ligação perdida. A tentar novamente…",
  wachtenOpAnder: "Já entraste. Aguarda que o outro faça a leitura do código QR.",
  allebeiInDeKamer: "Estão ambos na sala.",
  anderIsWeg: "O outro saiu",
  anderSpreekt: "O outro está a falar…",
  jeKuntErNietIn: "Não podes entrar",
  overgenomenTitel: "Continuado noutro dispositivo",
  overgenomenUitleg: "Esta conversa acabou de ser aberta noutro dispositivo. Continua a falar por lá.",
  terug: "Voltar",
  geluidStaatUit: "O som está desligado. Toca em qualquer parte do ecrã.",
  tikHier: "toca aqui",
  bewaardTot: 'Guardado até {tijd}',
  bewaardVast: "Sala permanente. As mensagens ficam guardadas durante 30 dias.",
  spreekIn: "Fala",
  luisteren: "A ouvir… toca para parar",
  uitschrijven: "A transcrever…",
  tijdOmTeVerbeteren: "Tempo para corrigir",
  altijdZelfVersturen: "Rever e enviar sempre manualmente",
  jijVerstuurtZelf: "Tu envias",
  uit: "desligado",
  sec: "seg",
  vertalingMeteenAfspelen: "Reproduzir tradução imediatamente",
  typHierJeBericht: "Escreve aqui a tua mensagem…",
  stuur: "Enviar",
  geenOpnameMogelijk: "Este navegador não consegue gravar áudio. Mas podes digitar.",
  verstaanAls: "Entendido como",
  tellerStaatStil: "o cronómetro está parado",
  versturen: "Enviar",
  wis: "Apagar",
  jijZei: "tu disseste",
  vertaald: "traduzido",
  duimOmhoog: "Está correto",
  duimOmlaag: "Não está correto",
  opnieuwProberenKnop: "Tentar novamente com um modelo melhor",
  opnieuwProberenBezig: "A traduzir novamente…",
  duimTranscriptWoordenlijstUitnodiging: "Mal entendido? Corrige no glossário:",
  instellingenAanpassen: "Ajustar definições",
  geldtVoorJullieBeiden: "Aplica-se a ambos",
  alleenVoorJou: "Apenas para ti",
  stuurMijnStemMee: "Enviar a minha própria voz",
  verbeterSpelfouten: "Corrigir erros ortográficos no meu texto",
  verbeterSpelfoutenUit: "Desativar mostra o que foi realmente entendido, com erros incluídos.",
  alleenChat: "Só chat: sem voz, sem microfone",
  alleenChatUitleg: "Ambos escrevem. A tradução e o texto original aparecem no ecrã; nada é lido em voz alta.",
  aangepastDoorDeAnder: "O outro alterou as definições.",
  foutSpraak: "A tradução está disponível, mas não houve som.",
  foutSpraakQuota: "O limite diário de voz terminou. O texto continua a funcionar; a voz regressa amanhã.",
  foutBudgetKamer: "Esta conversa atingiu o limite, por isso a tradução está em pausa. Quem a criou pode aumentá-lo; depois volta a funcionar de imediato.",
  foutBudgetMaand: "O orçamento mensal da aplicação esgotou-se. A tradução volta a funcionar quando o administrador o ajustar.",
  foutTaal: "Essa língua não é possível: ambos estariam a falar a mesma.",
  origineel: "original",
  vertalen: "A traduzir…",
  vertalenMislukt: "Não foi possível traduzir.",
  opnieuwAfspelen: "Reproduzir tradução novamente",
  hoorDeAnder: "Ouve como o outro o disse",
  woordenlijst: "Glossário de segurança",
  woordenlijstUitleg: "A app entende constantemente mal um nome ou termo técnico? Define aqui o que queres dizer.",
  hijHoort: "ele ouve…",
  jijBedoelt: "tu queres dizer…",
  ookVolgendeGesprekken: "Também em conversas futuras — caso contrário, aplica-se apenas a esta",
  voegToe: "Adicionar",
  bezig: "A processar…",
  lijstNietGeladen: "Não foi possível carregar a lista.",
  toevoegenMislukt: "Não foi possível adicionar.",
  verwijderenMislukt: "Não foi possível remover.",
  overal: "em todo o lado",
  verwijder: "Remover",
  overDitGesprek: "Sobre esta conversa",
  toon: "Tom da tradução",
  sfeer: "Tom da conversa",
  jouwPlek: "O teu lugar",
  hoeHetWerkt: "O servidor transcreve a tua gravação e traduz-la de uma só vez. A tua própria voz é enviada para o outro.",
  kleinereTekst: "Texto mais pequeno",
  grotereTekst: "Texto maior",
  insprekenVerbergen: "Ocultar voz",
  insprekenTonen: "Mostrar voz",
  toetsenbordVerbergen: "Ocultar teclado",
  toetsenbordTonen: "Mostrar teclado",
  vormAutomatisch: "Automático",
  vormInformeel: "Informal",
  vormFormeel: "Formal",
  sfeerNeutraal: "Neutro",
  sfeerZakelijk: "Profissional",
  sfeerOfficieel: "Oficial",
  sfeerVriendschappelijk: "Amigável",
  sfeerPartner: "Parceiro",
  foutKamerVol: "Esta sala está cheia. Só são permitidas duas pessoas.",
  plekBezetTitel: "O teu lugar está ocupado",
  plekBezetUitleg: "Já está alguém do teu lado desta conversa, na tua língua. Normalmente és tu: a conversa ainda está aberta noutro dispositivo ou noutro separador. Fecha-a lá e tenta de novo. Às vezes demora um minuto e meio até o lugar ficar livre.",
  plekBezetWissel: "És tu? Escreve WISSEL para trazer a conversa para este dispositivo. O outro dispositivo fecha-se.",
  plekBezetKnop: "Trazer para este dispositivo",
  foutKamerVerlopen: "Esta sala expirou ou foi fechada.",
  foutKamerOnbekend: "Esta sala não existe.",
  foutPinNodig: "Esta sala requer um código PIN.",
  foutPinFout: "O código PIN está incorreto.",
  foutProtocol: "A app e o servidor não se entendem. Atualiza a página.",
  foutMicroGeweigerd: "Recusaste o acesso ao microfone. Clica no cadeado na barra de endereço e ativa-o.",
  foutGeenMicro: "Nenhum microfone encontrado. Liga um e tenta novamente.",
  foutMicroInGebruik: "O microfone está a ser usado por outra aplicação. Fecha-a e tenta novamente.",
  foutGeenHttps: "O microfone só funciona numa ligação segura. Abre esta página via https.",
  foutMicroOnbekend: "Não foi possível iniciar o microfone.",
  foutNietsOpgenomen: "Nada foi gravado. O teu microfone está ligado?",
  foutNietsGehoord: "Não se ouviu nada. O teu microfone está ligado e estás a falar suficientemente alto?",
  foutOpnameTeLang: "A gravação é demasiado longa. Fala em frases mais curtas.",
  foutMicroGedempt: "O teu microfone está sem som. Ativa-o e tenta novamente.",

  // --- microfoontest ---
  micTitel: "Teste do microfone",
  micOnderschrift: "Quatro testes seguidos, cinco segundos cada. Continua a falar o tempo todo.",
  micStart: "Iniciar o teste",
  micTest1: "1. Só reconhecimento",
  micTest2: "2. Só gravação",
  micTest3: "3. Juntos — gravação primeiro",
  micTest4: "4. Juntos — reconhecimento primeiro",
  micFase1: "1 de 4: só reconhecimento — diz uma frase curta",
  micFase2: "2 de 4: só gravação — continua a falar",
  micFase3: "3 de 4: gravação primeiro, depois reconhecimento — continua a falar",
  micFase4: "4 de 4: reconhecimento primeiro, depois gravação — continua a falar",
  micKlaar: "pronto",
  micGehoord: "ouvido",
  micOpnameformaat: "Formato de gravação",
  micGeen: "nenhum",
  micBeveiligd: "Ligação segura",
  micJa: "sim",
  micNee: "NÃO",
  micBrowser: "Navegador",
  micGeenHttps: "Sem https o navegador não liberta o microfone. Em localhost é permitido.",
  micGeenHerkenning: "Este navegador não tem reconhecimento de voz.",
  micZegIets: "diz alguma coisa…",
  micWoordenBinnen: "estão a chegar palavras",
  micKonNietStarten: "não conseguiu arrancar",
  micGeenRecorder: "Este navegador não conhece o MediaRecorder.",
  micOpnemen: "a gravar…",
  micNietsOpgenomen: "nada gravado",
  micGeenMicrofoon: "sem microfone",
  micOpnameEerst: "gravação primeiro…",
  micHerkenningEerst: "reconhecimento primeiro…",
  micOpnameStarttNiet: "a gravação não arrancou",
  micSamenGelukt: "Juntos. Gravação {kb} kB.",
  micAlleenOpname: "Gravação sim, reconhecimento não.",
  micAlleenHerkenning: "Reconhecimento sim, gravação não.",
  micGeenVanBeide: "Nenhum dos dois.",
  micNetwerkFout: "O reconhecimento de voz não conseguiu chegar ao servidor.",
  micAfgebroken: "A gravação foi interrompida.",
  verslagTitel: "Registo da conversa",
  verslagWie: "Quem",
  verslagOrigineel: "Original",
  verslagVertaling: "Tradução",
  verslagSpreker: "Interlocutor {x}",
  verslagBerichten: "Mensagens",
  verslagGemaaktOp: "Criado em",
  verslagGeenOpname: "Não é uma gravação literal.",
  verslagNootOrigineel: "«Original» é o texto tal como a aplicação entendeu quem falava.",
  verslagNootCorrectie: "A correção ortográfica estava ativada: pequenos erros de escrita foram corrigidos.",
  verslagNootAangepast: "Quem falou pôde ainda alterar o texto antes de o enviar.",
  verslagGesproken: "falado",
  verslagGetypt: "escrito",
  verslagMislukt: "A tradução falhou. A outra pessoa não viu esta frase na sua língua.",
  verslagNietKlaar: "A tradução ainda não estava pronta quando este registo foi criado.",
  verslagVertrouwelijk: "Confidencial.",
  verslagAlleenDeelnemers: "Este registo contém o conteúdo de uma conversa privada e destina-se apenas aos participantes.",
  verslagGewist: "Data de eliminação da conversa: {tijd}. Depois disso, este registo não poderá ser criado novamente.",
  verslagGewistVast: "Sala permanente: cada mensagem é apagada 30 dias depois de ser enviada. As mensagens mais antigas não constam deste registo.",
};
